import React from 'react';
import styled from 'styled-components';
import WikiTerm from './WikiTerm';

const TestContainer = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  color: var(--c-text-primary);
`;

const Title = styled.h1`
  color: var(--c-text-primary);
  margin-bottom: 20px;
`;

const Content = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: var(--c-text-secondary);
`;

export default function Test() {
  return (
    <TestContainer>
      <Title>위키피디아 용어 설명 테스트</Title>
      <Content>
        <p>
          현대 사회에서 <WikiTerm term="필터 버블">필터 버블</WikiTerm>은 
          개인화된 알고리즘으로 인해 발생하는 정보의 편향성을 의미합니다. 
          이는 <WikiTerm term="에코 챔버">에코 챔버</WikiTerm> 현상과도 
          밀접한 관련이 있습니다.
        </p>
        <p>
          최근 <WikiTerm term="조국 사태">조국 사태</WikiTerm>와 같은 
          사회적 이슈에서도 이러한 현상이 두드러지게 나타났습니다.
        </p>
      </Content>
    </TestContainer>
  );
}
